import React from "react";

/**
 * Reusable footer for public-facing pages
 */
const PublicFooter: React.FC = () => {
  return (
    <div className="w-full p-4 border-t border-secondary/20 text-center text-sm text-muted-foreground">
      <p>© {new Date().getFullYear()} Hirelo. All rights reserved.</p>
      <div className="mt-2">
        <a
          href="https://www.hirelo.io/privacy"
          className="text-secondary hover:underline mx-2"
        >
          Privacy Statement
        </a>
        <a
          href="https://www.hirelo.io/terms"
          className="text-secondary hover:underline mx-2"
        >
          Terms & Conditions
        </a>
        <a
          href="https://www.hirelo.io/faq"
          className="text-secondary hover:underline mx-2"
        >
          FAQs
        </a>
      </div>
    </div>
  );
};

export default PublicFooter;
